export default "__VITE_ASSET__CXjEM_0Y__"